import { render, staticRenderFns } from "./RecommendedPlaylists.vue?vue&type=template&id=190ab5c4"
import script from "./RecommendedPlaylists.vue?vue&type=script&lang=js"
export * from "./RecommendedPlaylists.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports